import React from "react";
import styled from "styled-components";
import { HeaderClose } from "../../styled/web-map/market-share/MarketShare.styled";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  margin-top: 5px;
  background: #ffffff 0% 0% no-repeat padding-box;
  color: white;
  border-bottom: 1.5px solid #70707030;
`;

const CardTitle = styled.div`
  text-align: left;
  font: normal normal 600 11px/12px Open Sans;
  letter-spacing: 0px;
  font-weight: bold;
  color: #000000;
  opacity: 0.6;
  align-items: center;
  margin-left: 3px;
  flex: 1;
`;

const InnerContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  padding-left: 1px;
  padding-right: 2px;
`

const Pointer = styled.div`
  position: absolute;
  top: -15px; /* Adjust position as needed */
  left: 10%; /* Adjust position as needed */
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-bottom: 16px solid #ffffff; /* Adjust color to match modal background */
  filter: drop-shadow(0px -1px 2px rgba(0,0,0,0.1)) drop-shadow(0px -2px 3px rgba(0,0,0,0)) drop-shadow(0px -1px 6px rgba(0,0,0,0));

  &::before {
    position: absolute;
    top: -20px; /* Adjust position as needed */
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 20px;
    background: transparent;
    filter: drop-shadow(0px -1px 2px rgba(0,0,0,0.1)) drop-shadow(0px -2px 3px rgba(0,0,0,0)) drop-shadow(0px -1px 6px rgba(0,0,0,0));
  }
`;


export const TableTooltipContainer = styled.div`
  top: ${({ top }) => {
    return `${top}px`;
  }};
  left: ${({ left }) => {
    return `${left}px`;
  }};
  width: ${({ width }) => {
    return `${width}vw`;
  }};
  z-index: 999;
  position: absolute;
  border-radius: 12px;
  background-color: #fff; /* Default background color */
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
`;

export default function CommonTableTooltip({
  rowPosition,
  tableRef,
  children,
  title,
  handleClose = () => {},
}) {
  const trPosition = rowPosition?.getBoundingClientRect();
  const containerPosition = tableRef?.current?.getBoundingClientRect();
  const containerWidth = containerPosition.width;
  const left = containerPosition.left + (containerWidth * 1) / 8;

  const existingTop =
    trPosition.bottom - containerPosition.top + (trPosition.height >= 40 ? trPosition.height/2 : trPosition.height );
  const additionalOffsetPercentage = window.devicePixelRatio > 1.25 ? 0.06 : 0.05;
  const additionalOffset =
    containerPosition.height * additionalOffsetPercentage;
  const top = existingTop + additionalOffset;

  const dynamicWidth = window.devicePixelRatio >= 1.25 ? 26 : 22;
  const increasedWidth = dynamicWidth + 4; // Adding 4vw more to the existing width


  return (
    <TableTooltipContainer top={top} left={left} width={increasedWidth}>
     <InnerContainer>
      <Pointer/>
      <ModalHeader>
        <CardTitle>{title || ""}</CardTitle>
        <HeaderClose>
          <div onClick={handleClose}>
            <CloseRoundedIcon style={{ color: "black", fontSize:'14px', opacity: 0.7 }} />{" "}
          </div>
        </HeaderClose>
      </ModalHeader>
      <div>{children}</div>
    </InnerContainer>
  </TableTooltipContainer>
  );
}
